const customSpanFormats = [
	'footnote-ref-tail',
	'webtext-figure-reference',
	'webtext-source-url',
	'webtext-math',
	'visually-hidden',
	'webtext-glossary-term-locations',
	'webtext-big-link-title',
	'webtext-big-link-credit',
	'webtext-pullquote-heading',
	'key-point',
	'webtext-article-source-name',
	'icon-tech-tip',
	'webtext-decoration'
];

const customFormats = [
	'rolloverText',
	'eyebrowHeading',
	'blockWithAttributes',
	'refWithAttributes',
	'divWithAttributes'
];

const headings = ['h1', 'h2', 'h3', 'h4', 'h5'];

export const formats = [
	'bold',
	'italic',
	'underline',
	'list',
	'link',
	'blockquote',
	'break',
	'script',
	'cite',
	...headings,
	...customFormats,
	...customSpanFormats
];
